import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterPipe',
  standalone: true,
})
export class FilterPipe implements PipeTransform {
  transform(values: any[], value: any, propName?: string): any[] {
    if (!values || value == null) return values;

    return propName ? values.filter(x => x[propName] === value) : values.filter(x => x === value);
  }
}
